import { FormBuilder } from "../../components/formBuilder";
import formDetails from "./forms/formDetails.json";
import formSetup from "./forms/formSetup.json";
import formFields from "./forms/formFields.json";
import classes from "./style/submissionPreview.module.css";
import { FunctionalButton } from "../../components/functionalButton";
import { StyledQuestion } from "pages/newPreQualify/components/styles";
import { AddSubmitPopUp } from "components/addSubmitPopUp";
import { useEffect, useState } from "react";
import ProjectPreviewPopUp from "components/projectPreviewPopUp";
import { convertPhoneNumberCanadaUSA } from "common/regex";
import { AddFinalizePopUp } from "components/addFinalizePopUp";
import PledgXeCQS from "assets/common/pledgxeCQS";
import handleFileDownload from "common/downloadFile";
import Spinner from "components/spinner";
import { isEmpty } from "lodash";
import { getCountryName } from "common/countryName";
import { getContractorCcdcsList } from "data/actions/serviceProvider";
import { getCCDCs } from "api/prequalify";
import { useDispatch, useSelector } from "react-redux";
import { ContractorCcdcListSelector } from "data/selectors/serviceProvider";
import { useHistory } from "react-router";
import { getECQSWizardContextSelector } from "../../data/selectors/ecqs";
import { eSubUser } from "../../data/actions/user";
import { reviewSingleEsub } from "../../api/esub";
import { numberWithCommas } from "common/numberFormat";

const SubmissionPreview = ({
  handleNext,
  prequalifyData,
  submitCqs = true,
  checkCcdcIdValue,
  checkSubmitStatus,
  ccdcData,
  setCcdcData,
  insuranceTypeList,
  setPrequalifyData,
  handleSavePreQualifyData,
  institutionId,
  currentDashboardUrl,
  handleShareOnline,
  isViewEsubPopupView
}) => {
  // ALL HOOKS MUST BE AT THE TOP - before any conditional logic
  const dispatch = useDispatch();
  const history = useHistory();

  console.log("submissionPreview prequalifyData", prequalifyData);
  console.log("submissionPreview bond_details", prequalifyData?.bond_details);
  console.log("submissionPreview project_info", prequalifyData?.project_info);
  
  // useState hooks
  const [state, setState] = useState({
    showInteractionPopup: { visible: false, data: {} },
  });
  const [openPopUp, setOpenPopup] = useState(false);
  const [openReviwPopup, setOpenReviewPopup] = useState(false);
  const [submitButton, setSubmitButton] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [reviewDisabled, setReviewedDisabled] = useState(false);
  const [ccdcList, setCcdcList] = useState(ccdcData);
  
  // useSelector hooks
  const contractorCcdcList = useSelector(ContractorCcdcListSelector);
  const wizardContext = useSelector(getECQSWizardContextSelector, null);
  const isEsub = wizardContext === "e-sub" || isViewEsubPopupView;
  
  // More useState hooks that depend on props
  const [selectedCountry, setSelectedCountry] = useState("United States");
  const [isSelectedCountry, isSetSelectedCountry] = useState(false);
  const [isCanada, isSetCanada] = useState(false);
  const [isUSA, isSetUSA] = useState(false);
  const [healthSafetyProgramList, setHealthSafetyProgramList] = useState("");
  const [healthSafetyProgramNo, setHealthSafetyProgramNo] = useState(false);
  const [healthSafetyProgramYes, setHealthSafetyProgramYes] = useState(false);
  const [
    healthSafetyEmployeeOrientationProgramNo,
    setHealthSafetyEmployeeOrientationProgramNo,
  ] = useState(false);
  const [
    healthSafetyEmployeeOrientationProgramYes,
    setHealthSafetyEmployeeOrientationProgramYes,
  ] = useState(false);
  const [corsRadioButtonNoYesNo, setCorsRadioButtonNoYesNo] = useState(false);
  const [healthSafetyProgramRemark, setHealthSafetyProgramRemark] = useState("");
  const [
    healthSafetyEmployeeOrientationProgramList,
    setHealthSafetyEmployeeOrientationProgramList,
  ] = useState("");
  const [
    healthSafetyEmployeeOrientationProgramRemark,
    setHealthSafetyEmployeeOrientationProgramRemark,
  ] = useState("");


  // useEffect hooks
  useEffect(() => {
    // Handle country logic first
    let countryForHS = "United States";
    if (
      getCountryName(prequalifyData?.project_info?.owner_country) === "Canada"
    ) {
      countryForHS = "Canada";
    } else {
      countryForHS = "United States";
    }
    setSelectedCountry(countryForHS);
    
    if (countryForHS === "United States") {
      isSetSelectedCountry(true);
      isSetUSA(true);
    } else {
      isSetCanada(true);
    }

    if (ccdcList?.length < 1) {
      getCcdcList();
    }
  }, []);
  
  useEffect(() => {
    if (contractorCcdcList?.length > 0) {
      setCcdcList(contractorCcdcList);
    }
  }, [contractorCcdcList]);

  useEffect(() => {
    const statusField = isEsub ? "esub_status" : "ccdc_status";
    const currentStatus = prequalifyData?.[statusField];
    
    if (
      currentStatus === "Reviewed" ||
      currentStatus === "Submitted" ||
      currentStatus === "Downloaded"
    ) {
      setReviewedDisabled(true);
      if (currentStatus === "Reviewed") {
        setSubmitButton(false);
      }
      if (currentStatus === "Submitted") {
        setSubmitButton(true);
      }
      setDisabled(false);
    }
    if (
      currentStatus === "" ||
      currentStatus === "Draft" ||
      !currentStatus
    ) {
      setReviewedDisabled(false);
      setDisabled(true);
      setSubmitButton(true);
    }
    
    // Set health safety program states
    if (
      prequalifyData?.annual?.remark_records?.health_safety_program === true
    ) {
      const healthSafetyProgram = prequalifyData?.annual?.remark_records?.health_safety_program_list;
      const healthSafetyProgramList = healthSafetyProgram
        ? healthSafetyProgram.map((item) => item.label).join(", ")
        : "";
      setHealthSafetyProgramList(healthSafetyProgramList);
      setHealthSafetyProgramYes(true);
    } else if (
      prequalifyData?.annual?.remark_records?.no_health_safety_program === true
    ) {
      const healthSafetyProgramRemark =
        prequalifyData?.annual?.remark_records?.no_health_safety_program_remark;
      setHealthSafetyProgramRemark(healthSafetyProgramRemark);
      setHealthSafetyProgramNo(true);
    }

    if (
      prequalifyData?.annual?.remark_records
        ?.health_safety_employee_orientation_program === true
    ) {
      const healthSafetyEmployeeOrientationProgram =
        prequalifyData?.annual?.remark_records?.health_safety_employee_orientation_program_list;
      const healthSafetyEmployeeOrientationProgramList =
        healthSafetyEmployeeOrientationProgram
          ? healthSafetyEmployeeOrientationProgram
              .map((item) => item.label)
              .join(", ")
          : "";
      setHealthSafetyEmployeeOrientationProgramList(
        healthSafetyEmployeeOrientationProgramList,
      );
      setHealthSafetyEmployeeOrientationProgramYes(true);
    } else if (
      prequalifyData?.annual?.remark_records
        ?.no_health_safety_employee_orientation_program === true
    ) {
      const healthSafetyEmployeeOrientationProgramRemark =
        prequalifyData?.annual?.remark_records
          ?.no_health_safety_employee_orientation_program_remark;
      setHealthSafetyEmployeeOrientationProgramRemark(
        healthSafetyEmployeeOrientationProgramRemark,
      );
      setHealthSafetyEmployeeOrientationProgramNo(true);
    }

    if (
      prequalifyData?.annual?.remark_records?.no_certificate_of_recognition ===
        true &&
      selectedCountry === "United States"
    ) {
      setCorsRadioButtonNoYesNo(false);
    }

    if (
      prequalifyData?.annual?.remark_records?.health_safety_program === true &&
      selectedCountry === "Canada"
    ) {
      setHealthSafetyProgramYes(false);
    }

    if (
      prequalifyData?.annual?.remark_records?.no_health_safety_program ===
        true &&
      selectedCountry === "Canada"
    ) {
      setHealthSafetyProgramNo(false);
    }
  }, [prequalifyData, ccdcList, selectedCountry, wizardContext]);

  // NOW we can have conditional logic and variable definitions
  const currentYear = new Date().getFullYear();
  const companyLogoImage = prequalifyData?.project_info?.gc_company_logo?.file;
  const healthSafetyProgram =
    prequalifyData?.annual?.remark_records?.health_safety_program_list;
  const healthSafetyEmployeeOrientationProgram =
    prequalifyData?.annual?.remark_records
      ?.health_safety_employee_orientation_program_list;

  const submitData = {
    ccdc_id: prequalifyData?.ccdcId || prequalifyData?.id || prequalifyData?.submission_id || prequalifyData?.ccdc_id,
    esub_id: prequalifyData?.esubId || prequalifyData?.id || prequalifyData?.submission_id || prequalifyData?.esub_id,
    rfpq_id: prequalifyData?.project_info?.rfpq_id,
  };

  const getCcdcList = async () => {
    if (
      currentDashboardUrl === "/service-provider-dashboard" &&
      institutionId
    ) {
      dispatch(
        getContractorCcdcsList(
          { institution_id: institutionId },
          () => {},
          () => {},
        ),
      );
    } else {
      await getCCDCs()
        .then((data) => {
          setCcdcList(data);
        })
        .catch((err) => {});
    }
  };

  //separate selected projects according to type
  const projects = prequalifyData?.projects;
  const underwayProjects = [];
  const keyProjects = [];
  const comparableProjects = [];
  if (projects) {
    projects.map((project) => {
      if (project) {
        project["type"]?.map((type) => {
          if (type === "underway") underwayProjects.push(project);
          if (type === "key") keyProjects.push(project);
          if (type === "comparable") comparableProjects.push(project);
        });
      }
    });
  }

  const insuranceListObject = { ...prequalifyData?.insuranceList };
  const selectedInsuranceData = insuranceListObject?.order?.map((key) => ({
    ...insuranceListObject?.state[key],
    type: insuranceTypeList?.find(
      (value) => value.short_form === insuranceListObject?.state[key].type,
    )
      ? insuranceTypeList?.find(
          (value) => value.short_form === insuranceListObject?.state[key].type,
        ).type
      : insuranceListObject?.state[key].type,
  }));
  insuranceListObject.state = selectedInsuranceData;

  const handleReviewed = () => {
    setOpenReviewPopup(false);
    setDisabled(false);
    setSubmitButton(false);
    setReviewedDisabled(true);

    if (isEsub) {
      setPrequalifyData("esub_status", "Reviewed");
    } else {
      setPrequalifyData("ccdc_status", "Reviewed");
    }
  };
  const handleReviewClick = () => {
    setOpenReviewPopup(true);
  };
  const handleInvite = () => {
    handleShareOnline();
  };

  const isESub = wizardContext === "e-sub" || isViewEsubPopupView;

  const data = {
    projectTitle: prequalifyData?.project_info?.project_title || "N/A",
    projectNumber: prequalifyData?.project_info?.project_number || "N/A",
    projectCategory: prequalifyData?.project_info?.categories || "N/A",
    projectOwner: isESub ? prequalifyData?.project_info?.owner_info?.owner_name : prequalifyData?.project_info?.owner_name || "N/A",
    projectOwnerEmail: isESub ? prequalifyData?.project_info?.owner_info?.owner_email : prequalifyData?.project_info?.owner_email || "N/A",
    projectOwnerPhone: convertPhoneNumberCanadaUSA(
      isESub ? prequalifyData?.project_info?.owner_info?.owner_phone : prequalifyData?.project_info?.owner_phone,
    ) || "N/A",
    ProjectLocation: prequalifyData?.project_info?.project_location_description || "N/A",
    projectOwnerAddress: (() => {
      const owner = isESub ? prequalifyData?.project_info?.owner_info : prequalifyData?.project_info;
      if (!owner) return "N/A";
      const address = [
        owner.owner_suite,
        owner.owner_address,
        owner.owner_city,
        owner.owner_province,
        owner.owner_postal_code
      ].filter(Boolean).join(", ");
      return address || "N/A";
    })(),
    companyName: prequalifyData?.project_info?.gc_name || "N/A",
    companyEmail: prequalifyData?.project_info?.gc_email || "N/A",
    companyContactNumber: convertPhoneNumberCanadaUSA(
      prequalifyData?.project_info?.gc_phone,
    ) || "N/A",
    companyWebsite: prequalifyData?.project_info?.gc_website || "N/A",
    companyLogo: prequalifyData?.project_info?.gc_company_logo || "N/A",
    companyLogoImage: companyLogoImage || "N/A",
    operationalCountry: prequalifyData?.project_info?.gc_operational_country || "N/A",
    operationalProvince: prequalifyData?.project_info?.gc_operational_province || "N/A",
    operationalRegion: prequalifyData?.project_info?.gc_operational_region || "N/A",
    yearEstablished: prequalifyData?.legal_structure?.establishment_year || "N/A",
    ventureType: prequalifyData?.legal_structure?.venture_type || "N/A",
    companyUnion: prequalifyData?.project_info?.gc_union || "N/A",
    companyAssociation: prequalifyData?.project_info?.gc_association || "N/A",
    companyAddress: (() => {
      const address = (prequalifyData?.project_info?.gc_suite_number
        ? prequalifyData?.project_info?.gc_suite_number + "-"
        : "") +
      (prequalifyData?.project_info?.gc_address
        ? prequalifyData?.project_info?.gc_address + ", "
        : "") +
      (prequalifyData?.project_info?.gc_city
        ? prequalifyData?.project_info?.gc_city + ", "
        : "") +
      (prequalifyData?.project_info?.gc_province
        ? prequalifyData?.project_info?.gc_province + ", "
        : "") +
      (prequalifyData?.project_info?.gc_postal_code || "");
      return address || "N/A";
    })(),

    businessCategory: prequalifyData?.project_info?.gc_categories || "N/A",
    legalStructurePersonnels: {
      selectedData: prequalifyData?.legal_structure?.personnel || [],
    },
    bankName: prequalifyData?.bank?.company_name || "N/A",

    bankAddress: (() => {
      const address = (prequalifyData?.bank?.suite_number &&
      prequalifyData?.bank?.suite_number !== "None"
        ? prequalifyData?.bank?.suite_number + "-"
        : "") +
      (prequalifyData?.bank?.address
        ? prequalifyData?.bank?.address + ","
        : "") +
      (prequalifyData?.bank?.city ? prequalifyData?.bank?.city + "," : "") +
      (prequalifyData?.bank?.province
        ? prequalifyData?.bank?.province + " "
        : "") +
      (prequalifyData?.bank?.postal || "");
      return address || "N/A";
    })(),

    bankContactName: (() => {
      const firstName = prequalifyData?.bank?.contact_first_name || "";
      const lastName = prequalifyData?.bank?.contact_last_name || "";
      const fullName = (firstName + " " + lastName).trim();
      return fullName || "N/A";
    })(),

    bankContactEmail: prequalifyData?.bank?.contact_email || "N/A",

    bondingCompanyName: prequalifyData?.bonding?.company_name || "N/A",
    bondingCompanyAddress: (() => {
      const address = (prequalifyData?.bonding?.suite_number &&
      prequalifyData?.bonding?.suite_number !== "None"
        ? prequalifyData?.bonding?.suite_number + "-"
        : "") +
      (prequalifyData?.bonding?.address
        ? prequalifyData?.bonding?.address + ","
        : "") +
      (prequalifyData?.bonding?.city
        ? prequalifyData?.bonding?.city + ","
        : "") +
      (prequalifyData?.bonding?.province
        ? prequalifyData?.bonding?.province + " "
        : "") +
      (prequalifyData?.bonding?.postal || "");
      return address || "N/A";
    })(),
    bondingCompanyContactName: (() => {
      const firstName = prequalifyData?.bonding?.contact_first_name || "";
      const lastName = prequalifyData?.bonding?.contact_last_name || "";
      const fullName = (firstName + " " + lastName).trim();
      return fullName || "N/A";
    })(),
    bondingCompanyContactEmail: prequalifyData?.bonding?.contact_email || "N/A",
    bondType: prequalifyData?.bond_details?.bond_type || "N/A",
    bondCurrency: prequalifyData?.bond_details?.bond_currency || "N/A",
    bondAmount: numberWithCommas(prequalifyData?.bond_details?.bond_amount) || "N/A",
    bondAggregateLimit: numberWithCommas(prequalifyData?.bonding?.bond_aggregate_limit) || "N/A",
    bondSingleProjectLimit: numberWithCommas(prequalifyData?.bonding?.bond_single_project_limit) || "N/A",
    insuranceDetails: { selectedData: insuranceListObject || [] },

    keyPersonnels: {
      selectedData: prequalifyData?.key_personnel || [],
    },
    healthSafetyPersonnelUSA: {
      selectedData: prequalifyData?.annual?.health_safety_personnel || [],
    },
    safetyRecords: prequalifyData?.annual?.safety_records || "N/A",
    safetyRecordsUSA: prequalifyData?.annual?.safety_records_usa || "N/A",
    safetyRecordsForPdf: prequalifyData?.annual?.safety_records_for_pdf || "N/A",
    safetyRecordsUSAForPdf: prequalifyData?.annual?.safety_records_usa_for_pdf || "N/A",
    selectedCountryForHealthSafety: selectedCountry || "N/A",
    isSelectedCountryForHealthSafety: isSelectedCountry || false,
    isSelectedCountryCanada: isCanada || false,
    isSelectedCountryUSA: isUSA || false,
    constructionRecords: prequalifyData?.annual?.annual_values || "N/A",
    constructionRecordsForPdf: prequalifyData?.annual?.annual_values_for_pdf || "N/A",
    safetyRecordsRemark:
      prequalifyData?.annual?.remark_records?.annual_safety_records_remark || "N/A",
    safetyRecordsRemarkUSA:
      prequalifyData?.annual?.remark_records?.annual_safety_records_remark_usa || "N/A",
    constructionRecordsRemark:
      prequalifyData?.annual?.remark_records?.annual_construction_value_remark || "N/A",
    corsRadioButtonYes:
      prequalifyData?.annual?.remark_records?.certificate_of_recognition || false,
    corsRadioButtonNo: corsRadioButtonNoYesNo || false,
    corsRadioButtonEquivalentToCor:
      prequalifyData?.annual?.remark_records
        ?.certificate_of_recognition_equivalent || false,
    corsRadioButtonCoveredByOther:
      prequalifyData?.annual?.remark_records
        ?.no_certificate_of_recognition_equivalent || false,
    healthSafetyEmployeeOrientationProgramYes:
      healthSafetyEmployeeOrientationProgramYes || false,
    healthSafetyProgramYes: healthSafetyProgramYes || false,
    healthSafetyProgramList: healthSafetyProgramList || [],
    healthSafetyProgramRemark: healthSafetyProgramRemark || "N/A",
    healthSafetyEmployeeOrientationProgramList:
      healthSafetyEmployeeOrientationProgramList || [],
    healthSafetyEmployeeOrientationProgramRemark:
      healthSafetyEmployeeOrientationProgramRemark || "N/A",
    healthSafetyEmployeeOrientationProgramNo:
      healthSafetyEmployeeOrientationProgramNo || false,
    healthSafetyProgramNo: healthSafetyProgramNo || false,
    healthSafetyPersonnelCanada: {
      selectedData: prequalifyData?.annual?.health_safety_personnel_canada || [],
    },
    corsRemark: prequalifyData?.annual?.remark_records?.cors_remark || "N/A",
    keyProjectsList: keyProjects || [],
    comparableProjectsList: comparableProjects || [],
    underwayProjectsList: underwayProjects || [],
    additionalDocument: prequalifyData?.additional_document || [],
    financialRecordsDocuments:
      prequalifyData?.annual?.financial_records_documents || [],
    healthSafetyDocumentsUSA:
      prequalifyData?.annual?.health_safety_documents_usa || [],
    healthSafetyDocumentsCanada:
      prequalifyData?.annual?.health_safety_documents_canada || [],
    institutionId: prequalifyData?.institution_id || "N/A",
    principalName: prequalifyData?.project_info?.principal_info?.principal_name || "N/A",
    principalEmail: prequalifyData?.project_info?.principal_info?.principal_email || "N/A",
    principalPhone: convertPhoneNumberCanadaUSA(prequalifyData?.project_info?.principal_info?.principal_phone) || "N/A",
    principalAddress: (() => {
      const principal = prequalifyData?.project_info?.principal_info;
      if (!principal) return "N/A";
      const address = [
        principal.principal_suite,
        principal.principal_address,
        principal.principal_city,
        principal.principal_province,
        principal.principal_postal_code
      ].filter(Boolean).join(", ");
      return address || "N/A";
    })(),
    obligeeName: prequalifyData?.project_info?.obligee_info?.obligee_name || "N/A",
    obligeeEmail: prequalifyData?.project_info?.obligee_info?.obligee_email || "N/A",
    obligeePhone: convertPhoneNumberCanadaUSA(prequalifyData?.project_info?.obligee_info?.obligee_phone) || "N/A",
    obligeeAddress: (() => {
      const obligee = prequalifyData?.project_info?.obligee_info;
      if (!obligee) return "N/A";
      const address = [
        obligee.obligee_suite,
        obligee.obligee_address,
        obligee.obligee_city,
        obligee.obligee_province,
        obligee.obligee_postal_code
      ].filter(Boolean).join(", ");
      return address || "N/A";
    })(),
    asAtDate: prequalifyData?.bond_details?.as_at_date || "N/A",
    contractPrice: numberWithCommas(prequalifyData?.bond_details?.contract_price) || "N/A",
    bidBondAmount: numberWithCommas(prequalifyData?.bond_details?.bid_bond_amount) || "N/A",
    
    bidder1: prequalifyData?.project_info?.gc_name || "N/A",
    bidder1Amount: numberWithCommas(prequalifyData?.bond_details?.contract_price) || "N/A",
    bidder2: prequalifyData?.bond_details?.bidder2_name || "N/A",
    bidder2Amount: numberWithCommas(prequalifyData?.bond_details?.bidder2_bid_amount) || "N/A",
    bidder3: prequalifyData?.bond_details?.bidder3_name || "N/A",
    bidder3Amount: numberWithCommas(prequalifyData?.bond_details?.bidder3_bid_amount) || "N/A",
    
    subcontractor1: (() => {
      const subcontractors = prequalifyData?.bond_details?.subcontractors;
      if (!subcontractors || !Array.isArray(subcontractors) || subcontractors.length === 0) {
        return "N/A";
      }
      return subcontractors[0]?.name || "N/A";
    })(),
    subcontractor1Amount: (() => {
      const subcontractors = prequalifyData?.bond_details?.subcontractors;
      if (!subcontractors || !Array.isArray(subcontractors) || subcontractors.length === 0) {
        return "N/A";
      }
      return numberWithCommas(subcontractors[0]?.amount) || "N/A";
    })(),
    subcontractor2: (() => {
      const subcontractors = prequalifyData?.bond_details?.subcontractors;
      if (!subcontractors || !Array.isArray(subcontractors) || subcontractors.length < 2) {
        return "N/A";
      }
      return subcontractors[1]?.name || "N/A";
    })(),
    subcontractor2Amount: (() => {
      const subcontractors = prequalifyData?.bond_details?.subcontractors;
      if (!subcontractors || !Array.isArray(subcontractors) || subcontractors.length < 2) {
        return "N/A";
      }
      return numberWithCommas(subcontractors[1]?.amount) || "N/A";
    })(),
    subcontractor3: (() => {
      const subcontractors = prequalifyData?.bond_details?.subcontractors;
      if (!subcontractors || !Array.isArray(subcontractors) || subcontractors.length < 3) {
        return "N/A";
      }
      return subcontractors[2]?.name || "N/A";
    })(),
    subcontractor3Amount: (() => {
      const subcontractors = prequalifyData?.bond_details?.subcontractors;
      if (!subcontractors || !Array.isArray(subcontractors) || subcontractors.length < 3) {
        return "N/A";
      }
      return numberWithCommas(subcontractors[2]?.amount) || "N/A";
    })(),
    penaltiesOrDamages: prequalifyData?.bond_details?.penalties_or_damages || "N/A",
    otherPenalties: prequalifyData?.bond_details?.other_penalties || "N/A",
    laborPercent: prequalifyData?.bond_details?.labor_percent || 0,
    materialPercent: prequalifyData?.bond_details?.material_percent || 0,
    subcontractorPercent: prequalifyData?.bond_details?.subcontractor_percent || 0,
    profitOverheadPercent: prequalifyData?.bond_details?.profit_overhead_percent || 0,
    jobCostBreakdownChart: (() => {
      const labor = prequalifyData?.bond_details?.labor_percent || 0;
      const material = prequalifyData?.bond_details?.material_percent || 0;
      const subcontractor = prequalifyData?.bond_details?.subcontractor_percent || 0;
      const profitOverhead = prequalifyData?.bond_details?.profit_overhead_percent || 0;
      const total = labor + material + subcontractor + profitOverhead;
      
      if (total === 0) return "No cost breakdown data available";
      
      return `Labor: ${labor}%\nMaterial: ${material}%\nSubcontractor: ${subcontractor}%\nProfit/Overhead: ${profitOverhead}%\nTotal: ${total}%`;
    })(),
    bondRemarks: prequalifyData?.bond_details?.remarks || "N/A",
  };

  //create an array of safetyRecords keys
  var safetyRecordRows = [];
  if (selectedCountry === "Canada") {
    if (data.safetyRecords) {
      Object.keys(data.safetyRecords).map((safetyRecordRow) =>
        safetyRecordRows.push({ id: safetyRecordRow, title: safetyRecordRow }),
      );
      safetyRecordRows.reverse();
    }
  }

  var safetyRecordUSARows = [];
  if (selectedCountry === "United States") {
    if (data.safetyRecordsUSA) {
      Object.keys(data.safetyRecordsUSA).map((safetyRecordUSARow) =>
        safetyRecordUSARows.push({
          id: safetyRecordUSARow,
          title: safetyRecordUSARow,
        }),
      );
      safetyRecordUSARows.reverse();
    }
  }

  //adding  "name" field with value of concating "firstname" and "lastName" to each personnel object
  if (data.keyPersonnels.selectedData)
    Object.values(data.keyPersonnels.selectedData).map(
      (value) => (value.name = value.firstName + " " + value.lastName),
    );

  if (data.healthSafetyPersonnelUSA.selectedData)
    Object.values(data.healthSafetyPersonnelUSA.selectedData).map(
      (value) => (value.name = value.firstName + " " + value.lastName),
    );
  if (data.healthSafetyPersonnelCanada.selectedData)
    Object.values(data.healthSafetyPersonnelCanada.selectedData).map(
      (value) => (value.name = value.firstName + " " + value.lastName),
    );
  if (data.legalStructurePersonnels.selectedData)
    Object.values(data.legalStructurePersonnels.selectedData).map(
      (value) => (value.name = value.firstName + " " + value.lastName),
    );

  // Modify formSetup to conditionally change page title based on wizardContext
  const modifiedFormSetup = formSetup.map(page => {
    if (page.id === "projectDetailPage") {
      return {
        ...page,
        pageTitle: isEsub ? "eSUB" : "RFP/Q"
      };
    }
    return page;
  });

  // Update navigation locations for CQS mode to ensure tabs work correctly
  // This fixes the issue where clicking a tab selects the wrong page
  if (!isEsub) {
    modifiedFormSetup.forEach((page, index) => {
      if (page.navigation?.current?.location) {
        page.navigation.current.location = [index];
      }
    });
  }
  
  if (isEsub) {
    const bondInfoPage = {
      "itemType": "page",
      "id": "bondInfoPage",
      "pageTitle": "Bond Info",
      "navigation": {
        "current": {
          "location": [1]
        }
      },
      "content": [
        {
          "itemType": "group",
          "id": "bondInfoGroup",
          "groupName": "Bond Information",
          "marginTop": "0",
          "content": [
            {
              "itemType": "field",
              "id": "bondType",
              "width": "33%"
            },
            {
              "itemType": "field",
              "id": "bondCurrency",
              "width": "33%"
            },
            {
              "itemType": "field",
              "id": "bondAmount",
              "width": "34%"
            }
          ]
        },
        {
          "itemType": "group",
          "id": "principalInfoGroup",
          "groupName": "Principal Information",
          "marginTop": "15px",
          "content": [
            {
              "itemType": "field",
              "id": "principalName",
              "width": "25%"
            },
            {
              "itemType": "field",
              "id": "principalEmail",
              "width": "25%"
            },
            {
              "itemType": "field",
              "id": "principalPhone",
              "width": "25%"
            },
            {
              "itemType": "field",
              "id": "principalAddress",
              "width": "25%"
            }
          ]
        },
        {
          "itemType": "group",
          "id": "obligeeInfoGroup",
          "groupName": "Obligee Information",
          "marginTop": "15px",
          "content": [
            {
              "itemType": "field",
              "id": "obligeeName",
              "width": "25%"
            },
            {
              "itemType": "field",
              "id": "obligeeEmail",
              "width": "25%"
            },
            {
              "itemType": "field",
              "id": "obligeePhone",
              "width": "25%"
            },
            {
              "itemType": "field",
              "id": "obligeeAddress",
              "width": "25%"
            }
          ]
        },
        {
          "itemType": "group",
          "id": "bidInfoGroup",
          "groupName": "Bid Information",
          "marginTop": "20px",
          "content": [
            {
              "itemType": "field",
              "id": "asAtDate",
              "width": "33%"
            },
            {
              "itemType": "field",
              "id": "contractPrice",
              "width": "33%"
            },
            {
              "itemType": "field",
              "id": "bidBondAmount",
              "width": "33%"
            }
          ]
        },
        {
          "itemType": "group",
          "id": "topBiddersGroup",
          "groupName": "Top 3 Bidders",
          "marginTop": "15px",
          "content": [
            {
              "itemType": "field",
              "id": "bidder1",
              "width": "50%"
            },
            {
              "itemType": "field",
              "id": "bidder1Amount",
              "width": "50%"
            }
          ]
        },
        {
          "itemType": "group",
          "id": "topBidders2Group",
          "content": [
            {
              "itemType": "field",
              "id": "bidder2",
              "width": "50%"
            },
            {
              "itemType": "field",
              "id": "bidder2Amount",
              "width": "50%"
            }
          ]
        },
        {
          "itemType": "group",
          "id": "topBidders3Group",
          "content": [
            {
              "itemType": "field",
              "id": "bidder3",
              "width": "50%"
            },
            {
              "itemType": "field",
              "id": "bidder3Amount",
              "width": "50%"
            }
          ]
        },

        {
          "itemType": "group",
          "id": "penaltiesGroup",
          "groupName": "Penalties and Damages",
          "marginTop": "20px",
          "content": [
            {
              "itemType": "field",
              "id": "penaltiesOrDamages"
            }
          ]
        },
        {
          "itemType": "group",
          "id": "otherPenaltiesGroup",
          "content": [
            {
              "itemType": "field",
              "id": "otherPenalties"
            }
          ]
        },
        {
          "itemType": "group",
          "id": "jobCostBreakdownGroup",
          "groupName": "Job Cost Breakdown",
          "marginTop": "20px",
          "content": [
            {
              "itemType": "field",
              "id": "laborPercent",
              "width": "50%"
            },
            {
              "itemType": "field",
              "id": "materialPercent",
              "width": "50%"
            }
          ]
        },
        {
          "itemType": "group",
          "id": "jobCostBreakdown2Group",
          "content": [
            {
              "itemType": "field",
              "id": "subcontractorPercent",
              "width": "50%"
            },
            {
              "itemType": "field",
              "id": "profitOverheadPercent",
              "width": "50%"
            }
          ]
        },
        {
          "itemType": "group",
          "id": "topSubcontractorsGroup",
          "groupName": "Top 3 Subcontractors",
          "marginTop": "20px",
          "content": [
            {
              "itemType": "field",
              "id": "subcontractor1",
              "width": "50%"
            },
            {
              "itemType": "field",
              "id": "subcontractor1Amount",
              "width": "50%"
            }
          ]
        },
        {
          "itemType": "group",
          "id": "topSubcontractors2Group",
          "content": [
            {
              "itemType": "field",
              "id": "subcontractor2",
              "width": "50%"
            },
            {
              "itemType": "field",
              "id": "subcontractor2Amount",
              "width": "50%"
            }
          ]
        },
        {
          "itemType": "group",
          "id": "topSubcontractors3Group",
          "content": [
            {
              "itemType": "field",
              "id": "subcontractor3",
              "width": "50%"
            },
            {
              "itemType": "field",
              "id": "subcontractor3Amount",
              "width": "50%"
            }
          ]
        },

        {
          "itemType": "group",
          "id": "bondRemarksGroup",
          "groupName": "Remarks",
          "marginTop": "20px",
          "content": [
            {
              "itemType": "field",
              "id": "bondRemarks"
            }
          ]
        }
      ]
    };
    
    // Insert Bond Info page as the second tab (position 1)
    // Insert the bond info page at position 1 first
    modifiedFormSetup.splice(1, 0, bondInfoPage);
    
    // Now update navigation locations for all pages after insertion
    modifiedFormSetup.forEach((page, index) => {
      if (page.navigation?.current?.location) {
        page.navigation.current.location = [index];
      }
    });
  }

  return (
    <>
      <StyledQuestion>
        {isEsub ? "PledgXeSUB" : <PledgXeCQS />}
      </StyledQuestion>
      <div className={classes["form-container"]}>
        {isEmpty(prequalifyData) ? (
          <div
            style={{
              height: "500px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Spinner />
          </div>
        ) : (
          <FormBuilder
            formFields={{
              ...formFields,
              ...(selectedCountry === "Canada"
                ? {
                    safetyRecords: {
                      ...formFields.safetyRecords,
                      rows: safetyRecordRows,
                    },
                  }
                : {
                    safetyRecordsUSA: {
                      ...formFields.safetyRecordsUSA,
                      rows: safetyRecordUSARows,
                    },
                  }),
            }}
            onInteractionItemClicked={(e) => {
              if (
                e.id === "keyProjectsList" ||
                e.id === "comparableProjectsList" ||
                e.id === "underwayProjectsList"
              ) {
                setState({
                  ...state,
                  showInteractionPopup: {
                    ...state.showInteractionPopup,
                    visible: true,
                    data: projects.find((project) => project.id === e.rowId),
                  },
                });
              }
              if (e.id === "additionalDocument") {
                handleFileDownload(e.rowId, e.name);
              }
            }}
            onResumeButtonClicked={(e) => {
              handleFileDownload(e.file_id, e.fileName);
            }}
            formSetup={modifiedFormSetup}
            formDetails={formDetails}
            navigationType="TABS"
            readOnly={true}
            data={data}
          />
        )}
      </div>
      <ProjectPreviewPopUp
        openPopup={state.showInteractionPopup.visible}
        setOpenPopup={(e) =>
          setState({
            ...state,
            showInteractionPopup: {
              ...ProjectPreviewPopUp.showInteractionPopup,
              visible: e,
            },
          })
        }
        data={state.showInteractionPopup.data}
      />
      {submitCqs && (
        <>
          <div className={classes["button-container"]}>
            <div
              style={{
                display: "flex",
                flex: 1,
                justifyContent: "flex-start",
              }}
            >
              <FunctionalButton
                buttonTitle="REVIEW"
                handleButton={() => handleReviewClick()}
                width="170px"
                disabled={reviewDisabled}
              />
              {prequalifyData?.project_info?.rfpq_id && (
                <FunctionalButton
                  buttonTitle="SUBMIT"
                  handleButton={() => {
                    setOpenPopup(true);
                  }}
                  width="170px"
                  marginRight="0"
                  disabled={submitButton}
                />
              )}
            </div>
            <div
              style={{ display: "flex", justifyContent: "flex-end", flex: 1 }}
            >
              {isESub && <FunctionalButton
                buttonTitle="INVITE"
                handleButton={handleInvite}
                width="170px"
                marginRight="16px"
                disabled={disabled && isESub}
              />}
              <FunctionalButton
                buttonTitle="EXPORT"
                handleButton={() => {
                  handleNext();
                }}
                width="170px"
                marginRight="0"
                disabled={disabled || isESub}
              />
            </div>
          </div>

          <AddSubmitPopUp
            openDialog={openPopUp}
            setOpenDialog={setOpenPopup}
            handleNext={handleNext}
            data={submitData}
            ccdcData={ccdcList}
            submitButton={submitButton}
            setPrequalifyData={setPrequalifyData}
            setSubmitButton={setSubmitButton}
          />
          <AddFinalizePopUp
            setOpenDialog={(e) => setOpenReviewPopup(e)}
            openDialog={openReviwPopup}
            prequalifyData={prequalifyData}
            onSuccess={() => handleReviewed()}
          />
        </>
      )}
    </>
  );
};

export default SubmissionPreview;
